module.exports = __webpack_public_path__ + "img/index-info4.7908ce52.jpg";